import React from "react";
import ProductCard from "./ProductCard";
import Container from "./Container";
import { Product, StoreSettings } from "@/types";

export interface ProductGridProps {
  products: Product[];
  store_settings: StoreSettings;
}

export function ProductGrid({ products, store_settings }: ProductGridProps): JSX.Element {
  return (
    <section className="py-6 md:py-12">
      <Container>
        {products.length > 0 ? (
          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
            {products.map((product, index) => (
              <div
                key={product.id}
                className="animate-fadeInUp"
                style={{ 
                  animationDelay: `${Math.min(index * 0.1, 1)}s`,
                  animationFillMode: 'both'
                }}
              >
                <ProductCard
                  product={product}
                  store_settings={store_settings}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20 animate-fadeIn">
            <div className="mb-4">
              <svg 
                className="mx-auto h-16 w-16 text-muted-foreground" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={1} 
                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2M4 13h2m13-8l-4 4-4-4-4 4-4-4" 
                />
              </svg>
            </div>
            <h2 className="text-2xl font-semibold mb-2">
              No se encontraron productos
            </h2>
            <p className="text-muted-foreground">
              Intenta ajustar tus filtros o vuelve a intentarlo más tarde.
            </p>
          </div>
        )}
      </Container>
    </section>
  );
}

export default ProductGrid;
